import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccessibilityCheckRow } from '../upload-accessibility-checks.component';

@Component({
    selector: 'app-upload-validation',
    imports: [CommonModule],
    templateUrl: './upload-validation.component.html',
    styleUrls: ['./upload-validation.component.scss'],
})
export class UploadValidationComponent implements OnInit {
    @Input() data: AccessibilityCheckRow[] = [];
    @Output() complete = new EventEmitter<AccessibilityCheckRow[]>();

    validRows: AccessibilityCheckRow[] = [];
    invalidRows: AccessibilityCheckRow[] = [];
    exampleRow: AccessibilityCheckRow | null = null;

    ngOnInit (): void {
        this.validateData();
    }

    validateData (): void {
        this.data.forEach(row => {
            const errors: string[] = [];

            if (!row.id) {
                errors.push('Database ID is required');
            }

            if (row.id && isNaN(Number(row.id))) {
                errors.push('Database ID must be a valid number');
            }

            if (row.impact) {
                const normalizedImpact = row.impact.toLowerCase();
                if (!['serious', 'moderate', 'minor'].includes(normalizedImpact)) {
                    errors.push('Impact must be: Serious, Moderate, or Minor');
                }
            }

            if (row.difficulty) {
                // Accept formats: "1 - Level 1", "Level 1", or just "1"
                const difficultyStr = row.difficulty.toString().trim();
                const levelMatch = difficultyStr.match(/^(\d+)(?:\s*-\s*Level\s*\d+)?$/i) || difficultyStr.match(/^Level\s*(\d+)$/i);

                if (levelMatch) {
                    const level = parseInt(levelMatch[1], 10);
                    if (level < 1 || level > 10) {
                        errors.push('Difficulty level must be between 1 and 10');
                    }
                } else {
                    errors.push('Difficulty must be a number between 1-10 or format "1 - Level 1"');
                }
            }

            if (errors.length > 0) {
                row.errors = errors;
                this.invalidRows.push(row);
            } else {
                this.validRows.push(row);
            }
        });

        this.exampleRow = this.validRows.length > 0 ? this.validRows[0] : null;
    }

    canProceed (): boolean {
        return this.validRows.length > 0;
    }

    getValidRowCount (): number {
        return this.validRows.length;
    }

    proceed (): void {
        this.complete.emit(this.validRows);
    }
}
